// ids can be in the format gid://shopify/ProductVariant/49808133914899 we just want the numbers
// so we split on the / and take the last element
const getIdFromGid = (gid) => {
  if (gid.includes('/')) {
    const parts = gid.split('/');
    return parts[parts.length - 1];
  }
  return gid;
};

const cart = () => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('items', []);
    Alpine.store('upsellOptions', []);
    Alpine.store('totalPrice', 0);
    Alpine.store('totalItems', 0);

    Alpine.data('cart', () => ({
      open: false,
      loading: true,
      addingUpsell: false,
      items: [],
      upsellOptions: [],
      totalPrice: 0,
      totalItems: 0,
      freeGiftValue: 60,
      freeGiftPercent: 50,
      freeGiftMessage: 'Spend £60 or more to get a free gift',
      freeGiftLowValueMessage: 'You are only £%{value} away from a free gift',
      freeGiftUnlockedMessage: 'You have unlocked a free gift!',
      displayFinalPrice(item) {
        // if price is zero return "FREE"
        if (item.final_price === 0) {
          return 'FREE';
        }
        console.log(item.discounted_price, item.final_price);
        if (item.discounted_price < item.final_price) {
          return this.$money(item.discounted_price);
        }

        return this.$money(item.final_price);
      },
      overlayOpen(e) {
        if (e.detail.overlay !== 'cart') {
          this.closeCart();
        }
      },
      init() {
        this.getCart();
        this.freeGiftValue = window.free_gift_value || 60;
        this.freeGiftMessage = window.free_gift_message || 'Spend £60 or more to get a free gift';
      },
      closeCart() {
        this.open = false;
        this.$dispatch('scroll:unlock', { element: this.$refs.cartScroll });
        this.$dispatch('overlay:close', { overlay: 'cart' });
      },
      openCart() {
        this.open = true;

        this.$dispatch('scroll:lock', { element: this.$refs.cartScroll });
        this.$dispatch('overlay:open', { overlay: 'cart' });
      },
      toggleCart() {
        this.open = !this.open;

        if (this.open) {
          this.$dispatch('scroll:lock', { element: this.$refs.cartScroll });
          this.$dispatch('overlay:open', { overlay: 'cart' });
        } else {
          this.$dispatch('scroll:unlock', { element: this.$refs.cartScroll });
          this.$dispatch('overlay:close', { overlay: 'cart' });
        }
      },
      getItemFromVariant(variantId) {
        return this.$store.items.find((item) => variantId.includes(item.variant_id));
      },
      updateFreeGiftMessaging() {
        // check if total price is greater than or equal to free gift value
        const totalPrice = this.$store.totalPrice / 100;

        this.freeGiftPercent = Math.round((totalPrice / this.freeGiftValue) * 100);
        this.freeGiftPercent = Math.min(this.freeGiftPercent, 100);

        if (totalPrice >= this.freeGiftValue) {
          this.freeGiftMessage = this.freeGiftUnlockedMessage;
        } else {
          const value = this.freeGiftValue - totalPrice;
          this.freeGiftMessage = this.freeGiftLowValueMessage.replace('%{value}', value);
        }

        if (totalPrice === 0) {
          this.freeGiftMessage = window.free_gift_message;
        }
      },
      getCart() {
        this.loading = true;

        return fetch(`${window.Shopify.routes.root}cart.js`)
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.total_price;
            this.$store.totalItems = res.item_count;

            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.total_price,
              totalItems: res.item_count,
            });

            this.getUpsellOptions();
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
            this.updateFreeGiftMessaging();
            this.updateWindowCartObject();
          });
      },
      makeid(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
          counter += 1;
        }
        return result;
      },
      getUpsellOptions() {
        const variantOptions = this.$store.items.map((item) => item.options_with_values);

        let query = '';

        const metafieldQuery = `
          metafield(key: "upsell_options", namespace: "custom") {
            value
          }
        `;

        if (this.$store.items.length === 0) {
          this.$store.upsellOptions = [];
          return;
        }

        // we'll use this later to tie the upsell back to the variant
        // that's in the cart
        const idsForMetafieldQuery = [];

        query = 'query {';
        this.$store.items.forEach((item) => {
          if (item.options_with_values.length === 0) {
            return;
          }

          const id = this.makeid(10);

          query += `
            ${id}: productByHandle(handle: "${item.handle}") {
              variantBySelectedOptions(selectedOptions: {name: "${item.options_with_values[0].name}", value: "${item.options_with_values[0].value}"}) {
                ${metafieldQuery}
                sub: metafield(key: "subscription_alternative", namespace: "custom") {
                  value
                }
                id
                image {
                  url(transform: {maxHeight: 200, maxWidth: 200})
                }
                sellingPlanAllocations(first: 10) {
                  nodes {
                    sellingPlan {
                      name
                      options {
                        name
                        value
                      }
                      id
                    }
                  }
                }
              }
            }
          `;
        });
        query += '}';

        const variantIds = [];
        const variantImgs = [];

        this.graphqlQuery(query)
          .then((d) => {
            query = '{';

            Object.keys(d.data).forEach((key) => {
              if (!d.data[key].variantBySelectedOptions.metafield) {
                return;
              }

              variantIds.push(d.data[key].variantBySelectedOptions.id);
              variantImgs.push(d.data[key].variantBySelectedOptions.image.url);

              const { value } = d.data[key].variantBySelectedOptions.metafield;

              const jsonValue = JSON.parse(value);

              jsonValue.forEach((v) => {
                const id = this.makeid(10);
                // add our metaobject id to the array
                idsForMetafieldQuery[id] = d.data[key].variantBySelectedOptions.id;

                query += `
              ${id}: metaobject(id: "${v}") {
                fields {
                  key
                  value
                  reference {
                    ... on ProductVariant {
                      image {
                        url(transform: {maxHeight: 200, maxWidth: 200})
                      }
                      product {
                        id
                      }
                    }
                  }
                }
              }
            `;
              });
            });

            query += '}';

            return this.graphqlQuery(query);
          })
          .then((d) => {
            if (d.data) {
              const upsellOptions = [];
              console.log(idsForMetafieldQuery);
              console.log(d.data);

              Object.keys(d.data).forEach((key, index) => {
                const { fields } = d.data[key];

                // check if fields has a show_in_cart key
                // if it does, check if the value is true
                // if it doesn't have the key, or the value is
                // false then we don't show the upsell option

                const showInCart = fields.find((field) => field.key === 'show_in_cart');
                if (showInCart && showInCart.value === 'false') {
                  return;
                }

                // create a fields object
                const fs = {};

                // check if fields has a product_variant key
                // if it does, then we need to get the variant id from the product
                // and check if it's already in the cart or not
                // if it is, then we need to remove it from the upsell options
                // if it's not, then we need to add it to the upsell options

                fields.forEach((field) => {
                  fs[field.key] = field.value;

                  if (field.key === 'product_variant') {
                    const variantId = field.value;
                    const productId = field.reference?.product?.id;

                    const variantInCart = this.$store.items.find((item) => productId.includes(item.product_id));

                    if (variantInCart) {
                      console.log('incart');
                    } else {
                      const upsellOption = {
                        id: variantId,
                        variantId: idsForMetafieldQuery[key],
                        image: field.reference?.image?.url,
                        productId: field.reference?.product?.id,
                        fields: fs,
                      };
                      upsellOptions.push(upsellOption);
                    }
                  }
                });
              });

              // need to make sure we don't add the same upsell option twice

              const uniqueUpsellOptions = [];

              upsellOptions.forEach((upsellOption) => {
                const variantId = upsellOption.id;

                const variantInUpsellOptions = uniqueUpsellOptions.find((item) => variantId.includes(item.id));

                if (!variantInUpsellOptions) {
                  uniqueUpsellOptions.push(upsellOption);
                }
              });

              this.$store.upsellOptions = uniqueUpsellOptions;
            }
          });
      },
      graphqlQuery: async (query) => {
        const res = await fetch(`${window.Shopify.routes.root}api/2023-10/graphql.json`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/graphql',
            'X-Shopify-Storefront-Access-Token': 'a9321fbc7c0de6615ce8603cc040a1f5',
          },
          body: query,
        });

        const data = await res.json();

        return data;
      },
      upsellClicked() {
        this.addingUpsell = true;
        const { variant, upsellVariant, upsellType } = this.$el.dataset;
        const uVA = upsellVariant.split('/');
        const vA = variant.split('/');

        const variantItem = this.getItemFromVariant(variant);

        if (upsellType === 'Same Product') {
          // remove existing item from cart
          this.removeItem(vA[vA.length - 1])
            .then(() => {
              // add upsell variant to cart

              const lineItem = {
                id: uVA[uVA.length - 1],
                quantity: 1,
              };

              if (variantItem.selling_plan_allocation?.selling_plan?.id) {
                lineItem.selling_plan = variantItem.selling_plan_allocation.selling_plan.id;
              }

              return this.addItem(lineItem);
            })
            .then(() => {
              this.getUpsellOptions();
            })
            .then(() => {
              this.addingUpsell = false;
            });
        }

        if (upsellType === 'Additional Product') {
          // update existing variant line item properties with upsell variant id
          // so we can remove the upsell item from the cart if the user removes the original item
          const data = {
            id: this.getItemFromVariant(variant).key,
            properties: {
              _upsell_variant: uVA[uVA.length - 1],
            },
          };

          this.changeItem(data)
            .then((res) => {
              this.$store.items = res.items;
              this.$store.totalPrice = res.total_price;
              this.$store.totalItems = res.item_count;

              this.$dispatch('cart:updated', {
                items: res.items,
                totalPrice: res.total_price,
                totalItems: res.item_count,
              });

              const lineItem = {
                id: uVA[uVA.length - 1],
                quantity: 1,
              };

              if (variantItem.selling_plan_allocation?.selling_plan?.id) {
                lineItem.selling_plan = variantItem.selling_plan_allocation.selling_plan.id;
              }

              return this.addItem(lineItem);
            })
            .then(this.getUpsellOptions())
            .then(() => {
              this.addingUpsell = false;
            })
            .catch((err) => {
              this.error = err;
            });
        }
      },
      async toggleSellingPlan(e) {
        const item = this.getItemFromVariant(this.$el.dataset.variant);

        const sellingPlanId = this.$el.closest('.sub-and-save').querySelector('select').value;
        let dataToAdd = {};
        let dataToRemove = {};

        if (e.target.checked) {
          // add sub to cart, remove one off
          dataToAdd = {
            id: this.$el.dataset.variant,
            selling_plan: sellingPlanId,
            quantity: parseInt(this.$el.dataset.lineQty),
            properties: {
              _sub_variant: `${this.$store.items[this.$el.dataset.index].variant_id}`,
              _selling_plan: `${this.$el.dataset.sellingPlan}`,
              _selling_plans: this.$el.dataset.sellingPlans,
            },
          };

          dataToRemove = {
            id: this.$el.dataset.lineKey,
            quantity: 0,
          };
        } else {
          // remove sub from cart, add one off
          dataToAdd = {
            id: this.$el.dataset.variant,
            quantity: parseInt(this.$el.dataset.lineQty),
            properties: {
              _sub_variant: `${this.$store.items[this.$el.dataset.index].variant_id}`,
              _selling_plan: `${this.$el.dataset.sellingPlan}`,
              _selling_plans: this.$el.dataset.sellingPlans,
            },
          };

          dataToRemove = {
            id: this.$el.dataset.lineKey,
            quantity: 0,
          };
        }

        const lineItems = [];
        lineItems.push(dataToAdd);

        this.loading = true;

        const addItemRes = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: lineItems }),
        });

        const addItemData = await addItemRes.json();

        const changeItemRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(dataToRemove),
        });

        const changeItemData = await changeItemRes.json();

        await this.getCart();

        this.$store.items = changeItemData.items;
        this.$store.totalPrice = changeItemData.total_price;
        this.$store.totalItems = changeItemData.item_count;

        this.$dispatch('cart:updated', {
          items: changeItemData.items,
          totalPrice: changeItemData.total_price,
          totalItems: changeItemData.item_count,
        });

        this.loading = false;
      },
      async sellingPlanChange(e) {
        const checkbox = e.target.closest('.sub-and-save').querySelector('input[type="checkbox"]');

        if (!checkbox.checked) {
          return;
        }
        this.loading = true;
        const dataToUpdate = {
          id: checkbox.dataset.lineKey,
          quantity: parseInt(checkbox.dataset.lineQty),
          selling_plan: this.$el.value,
          properties: {
            _sub_variant: `${this.$store.items[checkbox.dataset.index].properties._sub_variant}`,
            _selling_plan: `${checkbox.dataset.sellingPlan}`,
            _selling_plans: checkbox.dataset.sellingPlans,
          },
        };

        const changeItemRes = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(dataToUpdate),
        });

        const changeItemData = await changeItemRes.json();

        await this.getCart();

        this.$store.items = changeItemData.items;
        this.$store.totalPrice = changeItemData.total_price;
        this.$store.totalItems = changeItemData.item_count;

        this.$dispatch('cart:updated', {
          items: changeItemData.items,
          totalPrice: changeItemData.total_price,
          totalItems: changeItemData.item_count,
        });

        this.loading = false;
      },
      changeItem(data) {
        this.loading = true;
        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.status && res.status !== 200) {
              throw new Error(res.description);
            }

            return res;
          })
          .catch((err) => {
            this.error = err;
          })
          .finally((res) => {
            this.loading = false;
          });
      },
      addItem(data) {
        this.loading = true;

        const lineItems = [];

        const lineItem = data;

        lineItems.push(lineItem);

        return fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: lineItems }),
        })
          .then((res) => res.json())
          .then((res) => {
            this.getCart();

            return res;
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
            this.updateWindowCartObject();
          });
      },
      removeItem(variantId) {
        this.loading = true;

        const updates = {
          updates: {
            [variantId]: 0,
          },
        };

        return fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        })
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.total_price;
            this.$store.totalItems = res.item_count;

            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.total_price,
              totalItems: res.item_count,
            });

            return res;
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
            this.updateFreeGiftMessaging();
            this.updateWindowCartObject();
          });
      },
      remove() {
        this.loading = true;

        const variantId = this.$el.dataset.variant;
        const upsellVariant = this.$el.dataset.upsellVariant;

        const updates = {
          updates: {
            [variantId]: 0,
          },
        };

        if (upsellVariant) {
          updates.updates[upsellVariant] = 0;
        }

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        })
          .then((res) => res.json())
          .then((res) => {
            this.$store.items = res.items;
            this.$store.totalPrice = res.total_price;
            this.$store.totalItems = res.item_count;

            this.$dispatch('cart:updated', {
              items: res.items,
              totalPrice: res.total_price,
              totalItems: res.item_count,
            });

            this.getUpsellOptions();
          })
          .catch((err) => {})
          .finally(() => {
            this.loading = false;
            this.updateFreeGiftMessaging();
            this.updateWindowCartObject();
          });
      },
      wisepopUpsellClicked(e) {
        /**
         * triggered when a wisepop upsell button is clicked
         */
        e.preventDefault();

        this.loading = true;

        const lastVariant = sessionStorage.getItem('last_variant_added_cart');
        const lastSellingPlan = sessionStorage.getItem('last_variant_selling_plan');
        const upsells = [];
        const lineItems = [];

        // check if upsellOptions contains a matching variantId to our lastVariant,
        // it could contain multiple upsells
        this.$store.upsellOptions.forEach((item) => {
          if (item.variantId.includes(lastVariant)) {
            upsells.push(item);
            const lineItem = {
              id: getIdFromGid(item.id),
              quantity: 1,
            };

            if (lastSellingPlan !== 'null') {
              lineItem.selling_plan = lastSellingPlan;
            }

            lineItems.push(lineItem);
          }
        });

        if (!upsells.length) {
          return;
        }

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: lineItems,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            if (res.status && res.status !== 200) {
              throw new Error(res.description);
            }

            this.$dispatch('cart:product-added', { sku: res.items[0].sku, variant: res.items[0].id });
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => {
            this.loading = false;
            this.updateWindowCartObject();
          });

        //// loop over upsells, click elements
        //upsells.forEach((item) => {
        //  const upsell = document.querySelector(`[data-variant="${item.variantId}"]`);

        //  if (upsell) {
        //    upsell.click();
        //  }
        //});
        // remove the last variant from session storage
        sessionStorage.removeItem('last_variant_added_cart');

        console.log('wisepopUpsellClicked', e);
        console.log('lastVariant', lastVariant);
        console.log('upsells', this.$store.upsellOptions);
        console.log('matchingUpsells', upsells);
      },
      updateWindowCartObject() {
        window.cart = this.$store.items;
        window.updateCartSkus();
      },
    }));
  });
};

export default cart;
